<!-- Vehicle Refund Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="onSearch()"
          class="form-control form-control-solid w-250px ps-13"
          placeholder="Search vehicles..." />
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
        <!-- Filter Button -->
        <div class="d-flex justify-content-end me-3">
          <button type="button" class="btn btn-sm btn-dark fw-bold d-flex" [class.active]="showFiltersForm"
            (click)="toggleFilters()">
            <i class="ki-duotone ki-filter fs-6 text-muted me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            <span>Filter</span>
          </button>
        </div>
        <!-- Export Excel Button -->
        <button
          type="button"
          class="btn btn-sm btn-primary me-3 text-nowrap"
          (click)="exportExcel()"
          [disabled]="isExportingExcel">
          <span *ngIf="isExportingExcel" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <i *ngIf="!isExportingExcel" class="ki-duotone ki-exit-up fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>{{ isExportingExcel ? 'Exporting...' : 'Export Excel' }}</span>
        </button>
        <button
          *ngIf="selectedVehicles.length > 0"
          type="button"
          class="btn btn-sm btn-success me-3"
          [disabled]="selectedVehicles.length === 0"
          (click)="copySelectedISL()">
          <i class="ki-duotone ki-copy fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Copy ISL# ({{ selectedVehicles.length }})
        </button>
        <button
          *ngIf="hasChanges"
          type="button"
          class="btn btn-sm btn-success me-3"
          (click)="onSave()">
          <i class="ki-duotone ki-check fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Save Changes
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFiltersForm" [@slideInOut]>
    <div class="row g-4">
      <!-- Row 1: Basic Info -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Stock Number</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.stock_number" placeholder="Enter stock number">
      </div>
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Chassis #</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.chassis_number" placeholder="Enter chassis number">
      </div>
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Car Insurance Company Name</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.car_insurance_company_name" placeholder="Enter company name">
      </div>
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Keyword Search</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.keyword_search" placeholder="Enter keyword">
      </div>

      <!-- Row 2: Quick Search -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Quick Search</label>
        <div class="d-flex gap-3 mt-2">
          <div class="form-check" *ngFor="let option of quickSearchOptions">
            <input class="form-check-input" type="radio" name="quick_search" [id]="'quick_search_' + option.value" [value]="option.value" [(ngModel)]="filters.quick_search">
            <label class="form-check-label fs-7" [for]="'quick_search_' + option.value">{{ option.label }}</label>
          </div>
        </div>
      </div>

      <!-- Row 3: Date Ranges - Purchased Date -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Purchased Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.purchase_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Purchased Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.purchase_date_to">
      </div>

      <!-- Initial Docs Rcvd Date -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Initial Docs Rcvd Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.initial_docs_rcvd_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Initial Docs Rcvd Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.initial_docs_rcvd_date_to">
      </div>

      <!-- Masho Date -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Masho Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.masho_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Masho Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.masho_date_to">
      </div>

      <!-- Row 4: More Date Ranges - Masho Validity Date -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Masho Validity Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.masho_validity_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Masho Validity Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.masho_validity_date_to">
      </div>

      <!-- Weight Tax Refund Date -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Weight Tax Refund Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.weight_tax_refund_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Weight Tax Refund Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.weight_tax_refund_date_to">
      </div>

      <!-- ETD -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">ETD From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.etd_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">ETD To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.etd_to">
      </div>

      <!-- Row 5: More Date Ranges - Recycle Fee Application Date -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Recycle Fee Application Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.recycle_fee_application_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Recycle Fee Application Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.recycle_fee_application_date_to">
      </div>

      <!-- Recycle Fee Refund Date -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Recycle Fee Refund Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.recycle_fee_refund_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Recycle Fee Refund Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.recycle_fee_refund_date_to">
      </div>

      <!-- Automobile Tax Refund Date -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Automobile Tax Refund Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.automobile_tax_refund_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Automobile Tax Refund Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.automobile_tax_refund_date_to">
      </div>

      <!-- Row 6: Final Date Ranges - Shaken Validity -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Shaken Validity From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.shaken_validity_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Shaken Validity To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.shaken_validity_to">
      </div>

      <!-- Car Insurance Cancellation Date -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Car Insurance Cancellation Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.car_insurance_cancellation_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Car Insurance Cancellation Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.car_insurance_cancellation_date_to">
      </div>

      <!-- Row 7: Action Buttons -->
      <div class="col-12">
        <div class="d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">
            <i class="ki-duotone ki-cross fs-6 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Clear Filters
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-6 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3 text-muted">Loading refunds...</p>
    </div>

    <!-- No Data State -->
    <div *ngIf="!isLoading && vehicles.length === 0" class="text-center py-10">
      <div class="text-gray-400 fs-1 mb-3">
        <i class="ki-duotone ki-car fs-3x">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
        </i>
      </div>
      <h3 class="text-gray-800 fs-2 fw-bold mb-3">No vehicles found</h3>
      <p class="text-gray-400 fs-6 mb-0">Try adjusting your search criteria</p>
    </div>

    <!-- Vehicles Table -->
    <div *ngIf="!isLoading && vehicles.length > 0" class="vh-refund-table-container">
      <div class="table-responsive">
        <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 vh-refund-table">
          <thead>
            <tr class="fw-bold text-muted bg-light">
              <!-- Sticky Checkbox + Stock Number Column -->
              <th class="sticky-column min-w-180px">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="isAllSelected()"
                      [indeterminate]="isIndeterminate()"
                      (change)="toggleSelectAll($event)" />
                  </div>
                  Stock Number
                </div>
              </th>
              <!-- Scrollable Columns -->
              <th class="min-w-150px">Chassis #</th>
              <th class="min-w-120px">Purchase Date</th>
              <th class="min-w-100px">DOCS RCVD</th>
              <th class="min-w-150px">Auction Hall Name</th>
              <th class="min-w-120px">Auction Number</th>
              <th class="min-w-100px">Lot No.</th>
              <th class="min-w-150px">Sales Person</th>
              <th class="min-w-150px">Initial DOCS RCVD Date</th>
              <th class="min-w-100px">Type</th>
              <th class="min-w-100px">Plate Have</th>
              <th class="min-w-120px">Plate No.</th>
              <th class="min-w-150px">Plate Received Date</th>
              <th class="min-w-150px">Shaken Validity</th>
              <th class="min-w-120px">Massho Date</th>
              <th class="min-w-150px">Massho Validity</th>
              <th class="min-w-100px">ETD</th>
              <th class="min-w-180px">Recycle Certificate No.</th>
              <th class="min-w-180px">Recycle Fee Applied Date</th>
              <th class="min-w-150px">Recycle Fee Deposit</th>
              <th class="min-w-150px">Recycle Fee Refund</th>
              <th class="min-w-180px">Recycle Fee Difference</th>
              <th class="min-w-180px">Recycle Fee Refund Date</th>
              <th class="min-w-120px">Weight Tax</th>
              <th class="min-w-180px">Weight Tax Refund Date</th>
              <th class="min-w-180px">Automobile Tax Paid</th>
              <th class="min-w-180px">Automobile Tax Refund</th>
              <th class="min-w-200px">Automobile Tax Difference</th>
              <th class="min-w-200px">Automobile Tax Refund Date</th>
              <th class="min-w-180px">Car Insurance Company</th>
              <th class="min-w-200px">Car Insurance Certificate No.</th>
              <th class="min-w-200px">Car Insurance Cancellation Date</th>
              <th class="min-w-180px">Car Insurance Refund</th>
              <th class="min-w-100px">Mehen Fax</th>
              <th class="min-w-120px">Memo</th>
              <th class="min-w-120px">Grand Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let vehicle of vehicles; trackBy: trackByFn" class="vehicle-row">
              <!-- Sticky Checkbox + Stock Number Column -->
              <td class="sticky-column">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="isVehicleSelected(vehicle._id)"
                      (change)="toggleVehicleSelection(vehicle._id, $event)" />
                  </div>
                  <span class="fw-bold text-primary">{{ getDisplayValue(vehicle.car_no) }}</span>
                </div>
              </td>
              <!-- Scrollable Columns -->
              <td class="text-nowrap">{{ getDisplayValue(vehicle.vin_no) }}</td>
              <td>{{ vehicle.created_at | dateFormat }}</td>
              <td class="text-center">
                <i class="ki-duotone ki-file fs-2 text-primary cursor-pointer"
                   title="Upload Documents"
                   (click)="openDocumentsModal(vehicle)">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </td>
              <td>{{ getDisplayValue(vehicle.hall_name) }}</td>
              <td>{{ getDisplayValue(vehicle.inventory_no) }}</td>
              <td>{{ getDisplayValue(vehicle.lot_no) }}</td>
              <td>{{ getDisplayValue(vehicle?.sales_person?.name) }}</td>
              <!-- Initial DOCS RCVD Date - Input -->
              <td>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'initial_docs_rcvd_date')"
                  (ngModelChange)="setFormValue(vehicle._id, 'initial_docs_rcvd_date', $event)" />
              </td>
              <!-- Type - Dropdown -->
              <td>
                <select
                  class="form-select form-select-sm"
                  [ngModel]="getFormValue(vehicle._id, 'type')"
                  (ngModelChange)="setFormValue(vehicle._id, 'type', $event)">
                  <option value="">Select</option>
                  <option *ngFor="let option of typeOptions" [value]="option.value">{{ option.label }}</option>
                </select>
              </td>
              <!-- Plate Have - Checkbox -->
              <td class="text-center">
                <div class="form-check form-check-custom form-check-solid">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [ngModel]="getFormValue(vehicle._id, 'plate_have')"
                    (ngModelChange)="setFormValue(vehicle._id, 'plate_have', $event)" />
                </div>
              </td>
              <!-- Plate No. - Input -->
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'plate_no')"
                  (ngModelChange)="setFormValue(vehicle._id, 'plate_no', $event)"
                  placeholder="Enter plate no." />
              </td>
              <!-- Plate Received Date - Input -->
              <td>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'plate_received_date')"
                  (ngModelChange)="setFormValue(vehicle._id, 'plate_received_date', $event)" />
              </td>
              <!-- Shaken Validity - Date Input -->
              <td>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'shaken_validity')"
                  (ngModelChange)="setFormValue(vehicle._id, 'shaken_validity', $event)" />
              </td>
              <!-- Massho Date - Button styled as Input -->
              <td>
                <button
                  type="button"
                  class="btn btn-input-style cursor-pointer"
                  [class.empty-value]="!getFormValue(vehicle._id, 'masho_apply_date')"
                  (click)="openMashoModal(vehicle)"
                  title="Manage Massho">
                  {{ getDisplayValue(vehicle?.masho_apply_date,'Enter date')}}
                </button>
              </td>
              <!-- Massho Validity - Button styled as Input -->
              <td>
                <button
                  type="button"
                  class="btn btn-input-style cursor-pointer"
                  [class.empty-value]="!getFormValue(vehicle._id, 'masho_valid_date')"
                  (click)="openMashoModal(vehicle)"
                  title="Manage Massho">
                  {{ getDisplayValue(vehicle?.masho_valid_date,'Enter validity') }}
                </button>
              </td>
              <!-- ETD - Placeholder -->
              <td>{{ getDisplayValue(vehicle?.ship?.sailing_date) }}</td>
              <!-- Recycle Certificate No. - Input -->
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'recycle_certificate_no')"
                  (ngModelChange)="setFormValue(vehicle._id, 'recycle_certificate_no', $event)"
                  placeholder="Enter certificate no." />
              </td>
              <!-- Recycle Fee Applied Date - Input -->
              <td>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'recycle_fee_applied_date')"
                  (ngModelChange)="setFormValue(vehicle._id, 'recycle_fee_applied_date', $event)" />
              </td>
              <!-- Recycle Fee Deposit - Display -->
              <td>{{ formatPrice(vehicle?.recycle_fee_paid) }}</td>
              <!-- Recycle Fee Refund - Input -->
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'recycle_fee_refund')"
                  (ngModelChange)="setFormValue(vehicle._id, 'recycle_fee_refund', $event)"
                  placeholder="Enter refund amount" />
              </td>
              <!-- Recycle Fee Difference - Placeholder -->
              <td>{{ formatPrice(getRecycleFeeDifference(vehicle)) }}</td>
              <!-- Recycle Fee Refund Date - Input -->
              <td>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'recycle_fee_refund_date')"
                  (ngModelChange)="setFormValue(vehicle._id, 'recycle_fee_refund_date', $event)" />
              </td>
              <!-- Weight Tax - Input -->
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'weight_tax')"
                  (ngModelChange)="setFormValue(vehicle._id, 'weight_tax', $event)"
                  placeholder="Enter tax amount" />
              </td>
              <!-- Weight Tax Refund Date - Input -->
              <td>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'weight_tax_refund_date')"
                  (ngModelChange)="setFormValue(vehicle._id, 'weight_tax_refund_date', $event)" />
              </td>
              <!-- Automobile Tax Paid - Display -->
              <td>{{ formatPrice(vehicle?.automobile_tax) }}</td>
              <!-- Automobile Tax Refund - Input -->
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'automobile_tax_refund')"
                  (ngModelChange)="setFormValue(vehicle._id, 'automobile_tax_refund', $event)"
                  placeholder="Enter refund amount" />
              </td>
              <!-- Automobile Tax Difference - Placeholder -->
              <td>{{ formatPrice(getAutomobileTaxDifference(vehicle)) }}</td>
              <!-- Automobile Tax Refund Date - Input -->
              <td>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'automobile_tax_refund_date')"
                  (ngModelChange)="setFormValue(vehicle._id, 'automobile_tax_refund_date', $event)" />
              </td>
              <!-- Car Insurance Company - Input -->
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'car_insurance_company')"
                  (ngModelChange)="setFormValue(vehicle._id, 'car_insurance_company', $event)"
                  placeholder="Enter company name" />
              </td>
              <!-- Car Insurance Certificate No. - Input -->
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'car_insurance_certificate_no')"
                  (ngModelChange)="setFormValue(vehicle._id, 'car_insurance_certificate_no', $event)"
                  placeholder="Enter certificate no." />
              </td>
              <!-- Car Insurance Cancellation Date - Input -->
              <td>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'car_insurance_cancellation_date')"
                  (ngModelChange)="setFormValue(vehicle._id, 'car_insurance_cancellation_date', $event)" />
              </td>
              <!-- Car Insurance Refund - Input -->
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'car_insurance_refund')"
                  (ngModelChange)="setFormValue(vehicle._id, 'car_insurance_refund', $event)"
                  placeholder="Enter refund amount" />
              </td>
              <!-- Mehen Fax - Checkbox -->
              <td class="text-center">
                <div class="form-check form-check-custom form-check-solid">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [ngModel]="getFormValue(vehicle._id, 'mehen_fax')"
                    (ngModelChange)="setFormValue(vehicle._id, 'mehen_fax', $event)" />
                </div>
              </td>
              <!-- Memo - Input -->
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(vehicle._id, 'memo')"
                  (ngModelChange)="setFormValue(vehicle._id, 'memo', $event)"
                  placeholder="Enter memo" />
              </td>
              <!-- Grand Total - Placeholder -->
              <td>{{ formatPrice(getGrandTotalRefund(vehicle)) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination -->
    <app-pagination
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>

<!-- Masho Manager Add/Edit Modal -->
<app-masho-manager-add-edit
  (mashoAdded)="onMashoAdded()"
  (mashoUpdated)="onMashoUpdated()">
</app-masho-manager-add-edit>

<!-- Vehicle Upload Documents Modal -->
<app-vehicle-upload-documents
  (documentsUploaded)="onDocumentsUploaded()">
</app-vehicle-upload-documents>
